import {Github, Linkedin, Menu, Moon, Sun, X} from 'lucide-react';
import {ReactElement, useState} from 'react';
import {LinkItem, Section} from 'types';

export interface NavBarProps {
  sections: Section[];
  socialLinks: LinkItem[];
  theme: 'light' | 'dark';
  onToggleTheme: () => void;
}

export function NavBar(props: NavBarProps): ReactElement {
  const {sections, socialLinks, theme, onToggleTheme} = props;
  const [menuOpen, setMenuOpen] = useState(false);

  const renderSocialIcon = (label: string) => {
    if (label === 'LinkedIn') {
      return <Linkedin aria-hidden="true" />;
    }

    return <Github aria-hidden="true" />;
  };

  return (
    <header className="navbar">
      <div className="navbar-inner">
        <a href="#top" className="navbar-brand" onClick={() => setMenuOpen(false)}>
          <span className="navbar-title-full">Sai Hemanth Bheemreddy</span>
          <span className="navbar-title-medium">Sai Hemanth</span>
          <span className="navbar-title-short">Hemanth</span>
        </a>

        <nav className="navbar-section-desktop" aria-label="Primary navigation">
          {sections.map((section) =>
            <a
              key={section.id}
              className="navbar-link"
              href={`#${section.id}`}
            >
              {section.name}
            </a>
          )}
        </nav>

        <div className="navbar-actions">
          <button
            type="button"
            className="icon-button"
            aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            onClick={onToggleTheme}
          >
            {theme === 'dark' ? <Sun aria-hidden="true" /> : <Moon aria-hidden="true" />}
          </button>

          <div className="navbar-socials">
            {socialLinks.map((link) => (
              <a key={link.href} href={link.href} className="icon-button" aria-label={link.label}>
                {renderSocialIcon(link.label)}
              </a>
            ))}
          </div>

          <button
            type="button"
            className="icon-button navbar-menu-button"
            aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
          </button>
        </div>
      </div>

      <div className={`navbar-mobile-panel ${menuOpen ? 'open' : ''}`}>
        <nav className="navbar-mobile-links" aria-label="Mobile navigation">
          {sections.map((section) =>
            <a
              key={section.id}
              className="navbar-mobile-link"
              href={`#${section.id}`}
              onClick={() => setMenuOpen(false)}
            >
              {section.name}
            </a>
          )}
        </nav>
      </div>
    </header>
  );
}
